import { render, staticRenderFns } from "./SafeControlList.vue?vue&type=template&id=22900324&scoped=true"
import script from "./SafeControlList.vue?vue&type=script&lang=js"
export * from "./SafeControlList.vue?vue&type=script&lang=js"
import style0 from "./SafeControlList.vue?vue&type=style&index=0&id=22900324&prod&lang=scss"
import style1 from "./SafeControlList.vue?vue&type=style&index=1&id=22900324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22900324",
  null
  
)

export default component.exports